import { addIcon } from '@/svg/add';
import { addPlaylistIcon } from '@/svg/addPlaylist';
import { addSquareIcon } from '@/svg/addSquare';
import { alarmIcon } from '@/svg/alarm';
import { arrowIcon } from '@/svg/arrow';
import { arrowRightIcon } from '@/svg/arrow-right';
import { arrowdownIcon } from '@/svg/arrowdown';
import { arrowupIcon } from '@/svg/arrowup';
import { attackIcon } from '@/svg/attack';
import { bellIcon } from '@/svg/bell';
import { boltIcon } from '@/svg/bolt';
import { calendarIcon } from '@/svg/calendar';
import { calendarSearchIcon } from '@/svg/calendar-search';
import { closeIcon } from '@/svg/close';
import { courseDownIcon } from '@/svg/course-down';
import { cronoIcon } from '@/svg/crono';
import { cupIcon } from '@/svg/cup';
import { defenseIcon } from '@/svg/defense';
import { documentIcon } from '@/svg/document';
import { dotIcon } from '@/svg/dot';
import { doubleArrowLeftIcon } from '@/svg/double_arrow_left';
import { doubleArrowRightIcon } from '@/svg/double_arrow_right';
import { downloadIcon } from '@/svg/download';
import { eyeIcon } from '@/svg/eye';
import { eyeOffIcon } from '@/svg/eye-off';
import { flagIcon } from '@/svg/flag';
import { footballIcon } from '@/svg/football';
import { footballBootsIcon } from '@/svg/football-boots';
import { goalsIcon } from '@/svg/goals';
import { heatMapIcon } from '@/svg/heat-map';
import { hiddenTextIcon } from '@/svg/hidden-text';
import { historyIcon } from '@/svg/history';
import { inIcon } from '@/svg/in';
import { injuriedIcon } from '@/svg/injuried';
import { keyIcon } from '@/svg/key';
import { letterIcon } from '@/svg/letter';
import { likeIcon } from '@/svg/like';
import { loginIcon } from '@/svg/login';
import { magniferIcon } from '@/svg/magnifer';
import { minimizeIcon } from '@/svg/minimize';
import { minusIcon } from '@/svg/minus';
import { moreIcon } from '@/svg/more';
import { moreFilteredIcon } from '@/svg/more_filtered';
import { networkPassesIcon } from '@/svg/network-passes';
import { newPlaylistIcon } from '@/svg/new-playlist';
import { opponentsIcon } from '@/svg/opponents';
import { opponentsBlueIcon } from '@/svg/opponents_blue';
import { opponentsFilteredIcon } from '@/svg/opponents_filtered';
import { outIcon } from '@/svg/out';
import { percentageIcon } from '@/svg/percentage';
import { playIcon } from '@/svg/play';
import { playbackSpeedIcon } from '@/svg/playbackSpeed';
import { playlistIcon } from '@/svg/playlist';
import { redCardIcon } from '@/svg/red-card';
import { reelIcon } from '@/svg/reel';
import { refreshIcon } from '@/svg/refresh';
import { scoutingIcon } from '@/svg/scouting';
import { seasonIcon } from '@/svg/season';
import { seasonBlueIcon } from '@/svg/season_blue';
import { seasonFilteredIcon } from '@/svg/season_filtered';
import { shareArrowIcon } from '@/svg/share-arrow';
import { shieldWarningIcon } from '@/svg/shield-warning';
import { shieldUIcon } from '@/svg/shieldU';
import { starIcon } from '@/svg/star';
import { starFilledIcon } from '@/svg/star-filled';
import { stretchingIcon } from '@/svg/stretching';
import { tacticalIcon } from '@/svg/tactical';
import { tacticalBlueIcon } from '@/svg/tactical_blue';
import { tacticalFilteredIcon } from '@/svg/tactical_filtered';
import { teamIcon } from '@/svg/team';
import { teamBlueIcon } from '@/svg/team_blue';
import { teamFilteredIcon } from '@/svg/team_filtered';
import { trashIcon } from '@/svg/trash';
import { trendIcon } from '@/svg/trend';
import { trendDownIcon } from '@/svg/trend_down';
import { trendUpIcon } from '@/svg/trend_up';
import { tvIcon } from '@/svg/tv';
import { twodimIcon } from '@/svg/twodim';
import { userIcon } from '@/svg/user';
import { userFilteredIcon } from '@/svg/user_filtered';
import { yellowCardIcon } from '@/svg/yellow-card';

export const ICONS = [
  addIcon,
  addPlaylistIcon,
  addSquareIcon,
  alarmIcon,
  arrowIcon,
  arrowdownIcon,
  arrowupIcon,
  arrowRightIcon,
  attackIcon,
  bellIcon,
  boltIcon,
  calendarIcon,
  calendarSearchIcon,
  closeIcon,
  courseDownIcon,
  cronoIcon,
  cupIcon,
  defenseIcon,
  documentIcon,
  dotIcon,
  doubleArrowLeftIcon,
  doubleArrowRightIcon,
  downloadIcon,
  eyeIcon,
  eyeOffIcon,
  flagIcon,
  footballIcon,
  footballBootsIcon,
  goalsIcon,
  heatMapIcon,
  historyIcon,
  hiddenTextIcon,
  keyIcon,
  letterIcon,
  likeIcon,
  loginIcon,
  magniferIcon,
  minimizeIcon,
  minusIcon,
  moreIcon,
  moreFilteredIcon,
  networkPassesIcon,
  newPlaylistIcon,
  opponentsIcon,
  opponentsBlueIcon,
  opponentsFilteredIcon,
  playIcon,
  playbackSpeedIcon,
  playlistIcon,
  reelIcon,
  refreshIcon,
  scoutingIcon,
  seasonIcon,
  seasonBlueIcon,
  seasonFilteredIcon,
  shareArrowIcon,
  shieldUIcon,
  shieldWarningIcon,
  starFilledIcon,
  starIcon,
  stretchingIcon,
  tacticalIcon,
  tacticalBlueIcon,
  tacticalFilteredIcon,
  teamIcon,
  teamBlueIcon,
  teamFilteredIcon,
  trashIcon,
  trendIcon,
  trendDownIcon,
  trendUpIcon,
  tvIcon,
  twodimIcon,
  userIcon,
  userFilteredIcon,
  outIcon,
  inIcon,
  injuriedIcon,
  yellowCardIcon,
  redCardIcon,
  percentageIcon,
];
